import viewCreditcard from './view-creditcard.js';
import viewPaysafecard from './view-paysafecard.js';
import viewNoFields from './view-nofields.js';
import viewSkrill from './view-skrill.js';
import viewDotpay from './view-dotpay.js';
import viewNotification from '../../commonview/lib/view-notification.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

/* the formTemplateCodeToFormTemplate has info about params that is important for the amounpage, other inputfields are done on the
 method-page, for example all input required for creditcard, or peselnumber for dotpay */
const formTemplateCodeToFormTemplate = {


	'CREDIT-CARD': { // 1
		// Credit Card
		paymentmodule: viewCreditcard
	},
	'EMAIL-CURRENCIES': { // 4
		// Skrill/ MoneyBookers
		paymentmodule: viewSkrill,
		currencyselector: true
	},
	'ONLY-CURRENCIES': { // 6
		// PaySafeCard
		paymentmodule: viewPaysafecard,
		currencyselector: true
	},
	trustly: { // 23, desktop had special form template for Trustly (without amount), but we use no-fields
		// Trustly
		paymentmodule: viewNoFields
	},
	'NO-FIELDS': { // 47
		paymentmodule: viewNoFields
	},
	'BANK-WIRE-WITHDRAW': { // 57
		// DotPay
		paymentmodule: viewDotpay
	}
};

let currentPaymentMethodId = 1;

function validModule(formTemplateCode) {
	const elm = (formTemplateCodeToFormTemplate[formTemplateCode] || null);
	const apiMustExist = ['create'];
	let valid = true;
	let method = null;
	if (formTemplateCode) {
		// TODO: refactoring
		apiMustExist.forEach((m) => {
			if (elm) {
				if (elm.paymentmodule && !elm.paymentmodule[m]) {
					valid = false;
					// console.warn(`view-paymentform:109:check: module:${elm.name}: missing method :${m}`);
				}
			} else {
				valid = false;
			}
		});
	} else {
		valid = false;
	}
	if (valid) {
		method = formTemplateCodeToFormTemplate[formTemplateCode].paymentmodule;
	}
	return method;
}

function getSelected() {
	const keys = [];
	let formTemplateCode = null;
	let paymentmodule = null;
	let currencyselector = false;
	Object.keys(formTemplateCodeToFormTemplate).forEach((key) => {
		if (formTemplateCodeToFormTemplate[key].selected) {
			keys.push(key);
		}
	});
	if (keys.length && keys.length > 1) {
		console.error('method-formTemplateCode-to-name:136:getSelected: can not have two methods as current methods:', keys);
	} else {
		formTemplateCode = (keys[0] || null);
		paymentmodule = validModule(formTemplateCode);
		currencyselector = (paymentmodule ? formTemplateCodeToFormTemplate[formTemplateCode] && formTemplateCodeToFormTemplate[formTemplateCode].currencyselector : false);
	}
	return {
		formTemplateCode,
		paymentmodule,
		currencyselector
	};
}

function closeAll() {
	Object.keys(formTemplateCodeToFormTemplate).forEach((key) => {
		if (formTemplateCodeToFormTemplate[key].paymentmodule && formTemplateCodeToFormTemplate[key].paymentmodule.close) {
			formTemplateCodeToFormTemplate[key].paymentmodule.close();
		}
	});
	if (viewNotification) {
		viewNotification.close();
	}
}

function initCurrentSelected(p, paymentMethodId) {
	const selected = getSelected();
	const module = selected.paymentmodule;
	/* add the paymentMethodId to initial parameters */
	let created = null;
	/* the paymentMethodId of the paymentmethod is parsed to the selected module, to reduce the positions of setting this parameter */
	if (module && module.init) {
		module.init(p, paymentMethodId);
	} else if (module && module.create) {
		created = module.create(p, paymentMethodId);
	}
	return created;
}
export default {
	displayAmountSelector() {
		/* TODO: siru is a method that requires preselected amounts that has template code 'NO-FIELDS' together with
		some other methods. Currently Siru is treated as a special case and has a method to return . */
		const selected = getSelected();
		return ((selected && selected.paymentmodule.displayAmountSelector) && selected.paymentmodule.displayAmountSelector());
	},
	displayCurrencySelector(id) {
		let requireSelector;
		if (id) {
			requireSelector = Boolean(formTemplateCodeToFormTemplate[id] && formTemplateCodeToFormTemplate[id].currencyselector);
		} else {
			const currentFormTemplateCode = getSelected().formTemplateCode;
			const currentFormTemplate = formTemplateCodeToFormTemplate[currentFormTemplateCode];
			requireSelector = (currentFormTemplate && currentFormTemplate.currencyselector);
		}
		return requireSelector;
	},
	disableamountinput() {
		/* siru is a method that does not allow typing of input into amountfield*/
		const selected = getSelected();
		return (selected && (typeof (selected.paymentmodule.disableAmountInput) !== 'undefined') && selected.paymentmodule.disableAmountInput());
	},
	getCurrentPaymentMethodId() {
		const selected = getSelected();
		return (selected && currentPaymentMethodId);
	},
	getCurrentPaymentModule() {
		return getSelected().paymentmodule;
	},
	init(newPaymentMethodId, newFormTemplateCode, p) {
		const currentFormTemplateCode = getSelected().formTemplateCode;
		const currentFormTemplate = formTemplateCodeToFormTemplate[currentFormTemplateCode];
		const newFormTemplate = formTemplateCodeToFormTemplate[newFormTemplateCode];
		const textkeysObj = viewTextkeys.depositflow();
		let currentModule = null;
		let couldSetValidModule = true;
		if (currentFormTemplate) {
			formTemplateCodeToFormTemplate[currentFormTemplateCode].selected = false;
		}
		if (newFormTemplate) {
			formTemplateCodeToFormTemplate[newFormTemplateCode].selected = true;
		}
		couldSetValidModule = validModule(newFormTemplateCode);
		if (couldSetValidModule) {
			// init with provided params
			currentModule = initCurrentSelected(p, newPaymentMethodId);
			currentPaymentMethodId = newPaymentMethodId;
		} else {
			console.warn('method-newPaymentMethodId-to-name:createCurrentForm: method newPaymentMethodId does not match to a valid method', newPaymentMethodId);
			viewNotification.show({
				titleTxt: newFormTemplateCode,
				// color: 'neutral', // awaiting designers input before using this setting - Sunny jan 2017
				mainTxt: `${textkeysObj['deposit-payment-method-not-supported']} ${newFormTemplateCode}`
			});
		}
		return currentModule;
	},
	isValid(formTemplateCode) {
		return validModule(formTemplateCode);
	},
	updateCurrent(state) {
		const module = getSelected().paymentmodule;
		if (module && module.update) {
			module.update(state);
		}
	},
	evalInput() {
		const module = getSelected().paymentmodule;
		let evalatedInput = null;
		if (module && module.evalInput) {
			evalatedInput = module.evalInput();
		}
		return evalatedInput;
	},
	close() {
		closeAll();
		return null;
	},
	closeCurrent() {
		const selected = getSelected();
		const module = selected.paymentmodule;
		if (module && module.close) {
			module.close();
		}
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/deposit-form-template-conf.js